<template>
    <div class="container">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        }
    }
</script>

<style scoped lang="scss">
    .container {
        overflow: hidden;
        box-shadow: $primary-shadow;
        border-radius: $rounded-corners;
        background-color: white;
    }
</style>